"use client";

var _objectSpread = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js")["default"];
var _objectWithoutProperties = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js")["default"];
var _regeneratorRuntime = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/regeneratorRuntime.js")["default"];
var _defineProperty = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/defineProperty.js")["default"];
var _asyncToGenerator = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/asyncToGenerator.js")["default"];
var _createForOfIteratorHelper = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js")["default"];
var _slicedToArray = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/slicedToArray.js")["default"];
var _toConsumableArray = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/toConsumableArray.js")["default"];
var _excluded = ["children", "count", "overscan", "itemSize", "shift", "horizontal", "keepMounted", "reverse", "cache", "ssrCount", "item", "onScroll", "onScrollEnd", "style"],
  _excluded2 = ["children", "row", "col", "cellHeight", "cellWidth", "overscan", "initialRowCount", "initialColCount", "item", "style"];
var e = require("react/jsx-runtime"),
  t = require("react"),
  n = require("react-dom");
var r = null,
  o = Math.min,
  i = Math.max,
  s = Math.abs,
  l = Math.floor,
  c = Array.isArray,
  d = setTimeout,
  f = function f(e, t, n) {
    return o(n, i(t, e));
  },
  u = function u(e) {
    return _toConsumableArray(e).sort(function (e, t) {
      return e - t;
    });
  },
  a = "function" == typeof queueMicrotask ? queueMicrotask : function (e) {
    Promise.resolve().then(e);
  },
  h = function h(e) {
    var t, n;
    return function () {
      return t || (t = !0, n = e()), n;
    };
  },
  _ = -1,
  v = function v(e, t, n) {
    var r = n ? "unshift" : "push";
    for (var _n = 0; _n < t; _n++) e[r](_);
    return e;
  },
  p = function p(e, t) {
    var n = e.t[t];
    return n === _ ? e.o : n;
  },
  g = function g(e, t, n) {
    var r = e.t[t] === _;
    return e.t[t] = n, e.i = o(t, e.i), r;
  },
  m = function m(e, t) {
    if (!e.l) return 0;
    if (e.i >= t) return e.u[t];
    e.i < 0 && (e.u[0] = 0, e.i = 0);
    var n = e.i,
      r = e.u[n];
    for (; n < t;) r += p(e, n), e.u[++n] = r;
    return e.i = t, r;
  },
  w = function w(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.l - 1;
    for (; n <= r;) {
      var _o = l((n + r) / 2),
        _i = m(e, _o);
      if (_i <= t) {
        if (_i + p(e, _o) > t) return _o;
        n = _o + 1;
      } else r = _o - 1;
    }
    return f(n, 0, e.l - 1);
  },
  S = function S(e, t, n) {
    var r = t - e.l;
    return e.i = n ? -1 : o(t - 1, e.i), e.l = t, r > 0 ? (v(e.u, r), v(e.t, r, n), e.o * r) : (e.u.splice(r), (n ? e.t.splice(0, -r) : e.t.splice(r)).reduce(function (t, n) {
      return t - (n === _ ? e.o : n);
    }, 0));
  },
  x = "undefined" != typeof window,
  y = function y() {
    return document.documentElement;
  },
  b = function b(e) {
    return e.ownerDocument;
  },
  I = function I(e) {
    return e.defaultView;
  },
  z = /*#__PURE__*/h(function () {
    return !!x && "rtl" === getComputedStyle(y()).direction;
  }),
  k = /*#__PURE__*/h(function () {
    return /iP(hone|od|ad)/.test(navigator.userAgent);
  }),
  R = /*#__PURE__*/h(function () {
    return "scrollBehavior" in y().style;
  }),
  T = function T(e) {
    return i(e.h(), e._());
  },
  M = function M(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
    var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var c = arguments.length > 4 ? arguments[4] : undefined;
    var d = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
    var f = !!l,
      a = [],
      h = 0,
      x = 0,
      y = 0,
      b = 0,
      I = 0,
      z = 0,
      R = 0,
      T = 0,
      M = 0,
      C = f ? [0, i(l - 1, 0)] : r,
      E = [0, 0],
      H = 0;
    var W = function (e, t, n) {
        return {
          o: n ? n[1] : t,
          t: n && n[0] ? v(n[0].slice(0, o(e, n[0].length)), i(0, e - n[0].length)) : v([], e),
          l: e,
          i: -1,
          u: v([], e)
        };
      }(e, t, c),
      J = new Set(),
      q = function q() {
        return y - x;
      },
      B = function B() {
        return q() + z + I;
      },
      O = function O(e) {
        return function (e, t, n, r) {
          if (r = o(r, e.l - 1), m(e, r) <= t) {
            var _o2 = w(e, t + n, r);
            return [w(e, t, r, _o2), _o2];
          }
          {
            var _o3 = w(e, t, void 0, r);
            return [_o3, w(e, t + n, _o3)];
          }
        }(W, e, h, E[0]);
      },
      _L = function L() {
        return function (e) {
          return e.l ? m(e, e.l - 1) + p(e, e.l - 1) : 0;
        }(W);
      },
      $ = function $(e) {
        return m(W, e) - z;
      },
      A = function A(e) {
        return p(W, e);
      },
      P = function P(e) {
        e && (k() && 0 !== T ? z += e : (I += e, b++));
      };
    return {
      v: function v() {
        return a;
      },
      p: function p() {
        return function (e) {
          return [e.t.slice(), e.o];
        }(W);
      },
      m: function m() {
        if (R) return E;
        var _O = O(i(0, B())),
          _O2 = _slicedToArray(_O, 2),
          e = _O2[0],
          t = _O2[1];
        return C && (e = o(e, C[0]), t = i(t, C[1])), 1 !== T && (e -= i(0, n)), 2 !== T && (t += i(0, n)), E = [i(e, 0), o(t, W.l - 1)];
      },
      S: function S() {
        return w(W, B());
      },
      I: function I() {
        return w(W, B() + h);
      },
      k: function k(e) {
        return W.t[e] === _;
      },
      R: function R() {
        return !!C && W.t.slice(i(0, C[0] - 1), o(W.l - 1, C[1] + 1) + 1).includes(_);
      },
      T: $,
      M: A,
      C: function C() {
        return W.l;
      },
      H: function H() {
        return y;
      },
      W: function W() {
        return 0 !== T;
      },
      _: function _() {
        return h;
      },
      J: function J() {
        return x;
      },
      h: _L,
      q: function q() {
        return b;
      },
      B: function B() {
        return R = I, I = 0, [R, 2 === M || q() + h >= _L()];
      },
      O: function O(e, t) {
        var n = [e, t];
        return J.add(n), function () {
          J["delete"](n);
        };
      },
      L: function L(e, t) {
        var n,
          o,
          l = 0;
        switch (e) {
          case 1:
            {
              var _e = R;
              R = 0;
              var _n2 = t - y,
                _i2 = s(_n2);
              _e && _i2 < s(_e) + 1 || 0 !== M || (T = _n2 < 0 ? 2 : 1), f && (C = r, f = !1), y = t, l = 4;
              var _c = q();
              _c >= -h && _c <= _L() && (l += 1, o = _i2 > h);
              break;
            }
          case 2:
            l = 8, 0 !== T && (n = !0, l += 1), T = 0, M = 0, C = r;
            break;
          case 3:
            {
              var _e2 = t.filter(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  e = _ref2[0],
                  t = _ref2[1];
                return W.t[e] !== t;
              });
              if (!_e2.length) break;
              P(_e2.reduce(function (e, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  t = _ref4[0],
                  n = _ref4[1];
                return (2 === M || (C ? t < C[0] : $(t) + (0 === T && 0 === M ? A(t) : 0) < q())) && (e += n - A(t)), e;
              }, 0));
              var _iterator = _createForOfIteratorHelper(_e2),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _step$value = _slicedToArray(_step.value, 2),
                    _t = _step$value[0],
                    _n3 = _step$value[1];
                  var _e3 = A(_t),
                    _r = g(W, _t, _n3);
                  d && (H += _r ? _n3 : _n3 - _e3);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              d && h && H > h && (P(function (e, t) {
                var n = 0;
                var r = e.t.filter(function (e, r) {
                    var o = e !== _;
                    return o && r < t && n++, o;
                  }),
                  o = e.o;
                return e.i = -1, ((e.o = function (e) {
                  var t = u(e),
                    n = e.length / 2 | 0;
                  return t.length % 2 == 0 ? (t[n - 1] + t[n]) / 2 : t[n];
                }(r)) - o) * i(t - n, 0);
              }(W, w(W, B()))), d = !1), l = 3, o = !0;
              break;
            }
          case 4:
            h !== t && (h = t, l = 3);
            break;
          case 5:
            t[1] ? (P(S(W, t[0], !0)), M = 2, l = 1) : S(W, t[0]);
            break;
          case 6:
            x = t;
            break;
          case 7:
            M = 1;
            break;
          case 8:
            C = O(t), l = 1;
        }
        l && (a = [], n && z && (I += z, z = 0, b++), J.forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            e = _ref6[0],
            t = _ref6[1];
          l & e && t(o);
        }));
      }
    };
  },
  C = x ? t.useLayoutEffect : t.useEffect,
  E = function E(e, t) {
    return t && z() ? -e : e;
  },
  H = function H(e, t, n, o, i, s) {
    var l = Date.now;
    var c = 0,
      f = !1,
      u = !1,
      a = !1,
      h = !1;
    var _ = function () {
        var t;
        var n = function n() {
            t != r && clearTimeout(t);
          },
          o = function o() {
            n(), t = d(function () {
              t = r, function () {
                if (f || u) return f = !1, void _();
                a = !1, e.L(2);
              }();
            }, 150);
          };
        return o.$ = n, o;
      }(),
      v = function v() {
        c = l(), a && (h = !0), s && e.L(6, s()), e.L(1, o()), _();
      },
      p = function p(t) {
        if (f || !e.W() || t.ctrlKey) return;
        var r = l() - c;
        150 > r && 50 < r && (n ? t.deltaX : t.deltaY) && (f = !0);
      },
      g = function g() {
        u = !0, a = h = !1;
      },
      m = function m() {
        u = !1, k() && (a = !0);
      };
    return t.addEventListener("scroll", v), t.addEventListener("wheel", p, {
      passive: !0
    }), t.addEventListener("touchstart", g, {
      passive: !0
    }), t.addEventListener("touchend", m, {
      passive: !0
    }), {
      A: function A() {
        t.removeEventListener("scroll", v), t.removeEventListener("wheel", p), t.removeEventListener("touchstart", g), t.removeEventListener("touchend", m), _.$();
      },
      P: function P() {
        var _e$B = e.B(),
          _e$B2 = _slicedToArray(_e$B, 2),
          t = _e$B2[0],
          r = _e$B2[1];
        t && (i(E(t, n), r, h), h = !1, r && e._() > e.h() && e.L(1, o()));
      }
    };
  },
  W = function W(e, t) {
    var n, r, o;
    var i = t ? "scrollLeft" : "scrollTop",
      s = t ? "overflowX" : "overflowY",
      l = /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(r, s) {
          var c, _c2, _c3, _e4, _t2, _c4, _c5, _o4, _s;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (n) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", void a(function () {
                  return l(r, s);
                }));
              case 2:
                o && o();
                c = function c() {
                  var t;
                  return [new Promise(function (n, r) {
                    t = n, o = r, function (e) {
                      return !!e._();
                    }(e) && d(r, 150);
                  }), e.O(2, function () {
                    t && t();
                  })];
                };
                if (!(s && R())) {
                  _context.next = 23;
                  break;
                }
              case 5:
                if (!(e.L(8, r()), e.R())) {
                  _context.next = 20;
                  break;
                }
                _c2 = c(), _c3 = _slicedToArray(_c2, 2), _e4 = _c3[0], _t2 = _c3[1];
                _context.prev = 7;
                _context.next = 10;
                return _e4;
              case 10:
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return");
              case 15:
                _context.prev = 15;
                _t2();
                return _context.finish(15);
              case 18:
                _context.next = 5;
                break;
              case 20:
                n.scrollTo(_defineProperty(_defineProperty({}, t ? "left" : "top", E(r(), t)), "behavior", "smooth"));
                _context.next = 39;
                break;
              case 23:
                _c4 = c(), _c5 = _slicedToArray(_c4, 2), _o4 = _c5[0], _s = _c5[1];
                _context.prev = 24;
                n[i] = E(r(), t);
                e.L(7);
                _context.next = 29;
                return _o4;
              case 29:
                _context.next = 34;
                break;
              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](24);
                return _context.abrupt("return");
              case 34:
                _context.prev = 34;
                _s();
                return _context.finish(34);
              case 37:
                _context.next = 23;
                break;
              case 39:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[7, 12, 15, 18], [24, 31, 34, 37]]);
        }));
        return function l(_x, _x2) {
          return _ref7.apply(this, arguments);
        };
      }();
    return {
      X: function X(l) {
        n = l, r = H(e, l, t, function () {
          return E(l[i], t);
        }, function (t, n, r) {
          if (r) {
            var _e5 = l.style,
              _t3 = _e5[s];
            _e5[s] = "hidden", d(function () {
              _e5[s] = _t3;
            });
          }
          n ? (l[i] = e.H() + t, o && o()) : l[i] += t;
        });
      },
      A: function A() {
        r && r.A();
      },
      Y: function Y(e) {
        l(function () {
          return e;
        });
      },
      j: function j(t) {
        t += e.H(), l(function () {
          return t;
        });
      },
      D: function D(t) {
        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          n = _ref8.align,
          r = _ref8.smooth,
          _ref8$offset = _ref8.offset,
          o = _ref8$offset === void 0 ? 0 : _ref8$offset;
        if (t = f(t, 0, e.C() - 1), "nearest" === n) {
          var _r2 = e.T(t),
            _o5 = e.H();
          if (_r2 < _o5) n = "start";else {
            if (!(_r2 + e.M(t) > _o5 + e._())) return;
            n = "end";
          }
        }
        l(function () {
          return o + e.J() + e.T(t) + ("end" === n ? e.M(t) - e._() : "center" === n ? (e.M(t) - e._()) / 2 : 0);
        }, r);
      },
      P: function P() {
        r && r.P();
      }
    };
  },
  J = function J(e, t) {
    var n;
    return {
      X: function X(r) {
        var o = t ? "scrollX" : "scrollY",
          i = b(r),
          s = I(i),
          l = i.body,
          c = function c(e, t, n) {
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var o = n ? "offsetLeft" : "offsetTop",
              i = r + (n && z() ? s.innerWidth - e[o] - e.offsetWidth : e[o]),
              l = e.offsetParent;
            return e !== t && l ? c(l, t, n, i) : i;
          };
        n = H(e, s, t, function () {
          return E(s[o], t);
        }, function (n, r) {
          r ? s.scroll(_defineProperty({}, t ? "left" : "top", e.H() + n)) : s.scrollBy(t ? n : 0, t ? 0 : n);
        }, function () {
          return c(r, l, t);
        });
      },
      A: function A() {
        n && n.A();
      },
      P: function P() {
        n && n.P();
      }
    };
  },
  q = function q(e, t) {
    var n = W(e, !1),
      r = W(t, !0);
    return {
      X: function X(e) {
        n.X(e), r.X(e);
      },
      A: function A() {
        n.A(), r.A();
      },
      Y: function Y(e, t) {
        n.Y(t), r.Y(e);
      },
      j: function j(e, t) {
        n.j(t), r.j(e);
      },
      D: function D(e, t) {
        n.D(t), r.D(e);
      },
      P: function P() {
        n.P(), r.P();
      }
    };
  },
  B = "current",
  O = function O(e, t) {
    if (c(e)) {
      var _iterator2 = _createForOfIteratorHelper(e),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _n4 = _step2.value;
          O(_n4, t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else e == r || "boolean" == typeof e || t.push(e);
  },
  L = function L(e, t) {
    var n = e.key;
    return n != r ? n : "_" + t;
  },
  $ = function $(e) {
    var n = t.useRef();
    return n[B] || (n[B] = e());
  },
  A = function A(e) {
    var n = t.useRef(e);
    return C(function () {
      n[B] = e;
    }, [e]), n;
  },
  P = function P(e) {
    var t;
    return {
      X: function X(n) {
        (t || (t = new (I(b(n)).ResizeObserver)(e))).observe(n);
      },
      U: function U(e) {
        t.unobserve(e);
      },
      A: function A() {
        t && t.disconnect();
      }
    };
  },
  X = function X(e, t) {
    var n;
    var o = t ? "width" : "height",
      i = new WeakMap(),
      s = P(function (t) {
        var s = [];
        var _iterator3 = _createForOfIteratorHelper(t),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _step3.value,
              _l = _step3$value.target,
              _c6 = _step3$value.contentRect;
            if (_l.offsetParent) if (_l === n) e.L(4, _c6[o]);else {
              var _e6 = i.get(_l);
              _e6 != r && s.push([_e6, _c6[o]]);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        s.length && e.L(3, s);
      });
    return {
      V: function V(e) {
        s.X(n = e);
      },
      F: function F(e, t) {
        return i.set(e, t), s.X(e), function () {
          i["delete"](e), s.U(e);
        };
      },
      A: s.A
    };
  },
  Y = function Y(e, t) {
    var n = t ? "width" : "height",
      o = t ? "innerWidth" : "innerHeight",
      i = new WeakMap(),
      s = P(function (t) {
        var o = [];
        var _iterator4 = _createForOfIteratorHelper(t),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _step4.value,
              _e7 = _step4$value.target,
              _s2 = _step4$value.contentRect;
            if (!_e7.offsetParent) continue;
            var _t4 = i.get(_e7);
            _t4 != r && o.push([_t4, _s2[n]]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        o.length && e.L(3, o);
      });
    var l;
    return {
      V: function V(t) {
        var n = I(b(t)),
          r = function r() {
            e.L(4, n[o]);
          };
        n.addEventListener("resize", r), r(), l = function l() {
          n.removeEventListener("resize", r);
        };
      },
      F: function F(e, t) {
        return i.set(e, t), s.X(e), function () {
          i["delete"](e), s.U(e);
        };
      },
      A: function A() {
        l && l(), s.A();
      }
    };
  },
  j = function j(e, t) {
    var n;
    var r = "height",
      o = "width",
      s = new WeakMap(),
      l = new Set(),
      c = new Set(),
      d = new Map(),
      f = function f(e, t) {
        return "".concat(e, "-").concat(t);
      },
      u = P(function (u) {
        var a = new Set(),
          h = new Set();
        var _iterator5 = _createForOfIteratorHelper(u),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _step5$value = _step5.value,
              _i3 = _step5$value.target,
              _l2 = _step5$value.contentRect;
            if (_i3.offsetParent) if (_i3 === n) e.L(4, _l2[r]), t.L(4, _l2[o]);else {
              var _e9 = s.get(_i3);
              if (_e9) {
                var _e10 = _slicedToArray(_e9, 2),
                  _t6 = _e10[0],
                  _n5 = _e10[1],
                  _i4 = f(_t6, _n5),
                  _s3 = d.get(_i4),
                  _c7 = [_l2[r], _l2[o]];
                var _u = void 0,
                  _2 = void 0;
                _s3 ? (_s3[0] !== _c7[0] && (_u = !0), _s3[1] !== _c7[1] && (_2 = !0)) : _u = _2 = !0, _u && a.add(_t6), _2 && h.add(_n5), (_u || _2) && d.set(_i4, _c7);
              }
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        if (a.size) {
          var _t5 = [];
          a.forEach(function (e) {
            var n = 0;
            c.forEach(function (t) {
              var r = d.get(f(e, t));
              r && (n = i(n, r[0]));
            }), n && _t5.push([e, n]);
          }), e.L(3, _t5);
        }
        if (h.size) {
          var _e8 = [];
          h.forEach(function (t) {
            var n = 0;
            l.forEach(function (e) {
              var r = d.get(f(e, t));
              r && (n = i(n, r[1]));
            }), n && _e8.push([t, n]);
          }), t.L(3, _e8);
        }
      });
    return {
      V: function V(e) {
        u.X(n = e);
      },
      F: function F(e, t, n) {
        return s.set(e, [t, n]), l.add(t), c.add(n), u.X(e), function () {
          s["delete"](e), u.U(e);
        };
      },
      A: u.A
    };
  },
  D = t.memo(function (_ref9) {
    var n = _ref9.G,
      o = _ref9.K,
      i = _ref9.N,
      s = _ref9.Z,
      l = _ref9.ee,
      c = _ref9.te,
      d = _ref9.ne,
      f = _ref9.re;
    var u = t.useRef(r);
    C(function () {
      return o(u[B], i);
    }, [i]);
    var a = t.useMemo(function () {
      var e = _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        position: l && f ? void 0 : "absolute"
      }, d ? "height" : "width", "100%"), d ? "top" : "left", 0), d ? z() ? "right" : "left" : "top", s), "visibility", !l || f ? "visible" : "hidden");
      return d && (e.display = "flex"), e;
    }, [s, l, f, d]);
    return "string" == typeof c ? e.jsx(c, {
      ref: u,
      style: a,
      children: n
    }) : e.jsx(c, {
      ref: u,
      style: a,
      index: i,
      children: n
    });
  }),
  U = function U(e) {
    return t.useReducer(e.v, void 0, e.v)[1];
  },
  V = function V(e, n) {
    return t.useMemo(function () {
      if ("function" == typeof e) return [e, n || 0];
      var t = function (e) {
        var t = [];
        return O(e, t), t;
      }(e);
      return [function (e) {
        return t[e];
      }, t.length];
    }, [e, n]);
  },
  F = t.forwardRef(function (_ref10, x) {
    var o = _ref10.children,
      i = _ref10.count,
      s = _ref10.overscan,
      l = _ref10.itemSize,
      c = _ref10.shift,
      d = _ref10.horizontal,
      f = _ref10.keepMounted,
      h = _ref10.cache,
      _ref10$startMargin = _ref10.startMargin,
      _ = _ref10$startMargin === void 0 ? 0 : _ref10$startMargin,
      v = _ref10.ssrCount,
      _ref10$as = _ref10.as,
      p = _ref10$as === void 0 ? "div" : _ref10$as,
      _ref10$item = _ref10.item,
      g = _ref10$item === void 0 ? "div" : _ref10$item,
      m = _ref10.scrollRef,
      w = _ref10.onScroll,
      S = _ref10.onScrollEnd;
    var _V = V(o, i),
      _V2 = _slicedToArray(_V, 2),
      y = _V2[0],
      b = _V2[1],
      I = t.useRef(r),
      z = t.useRef(!!v),
      k = A(w),
      R = A(S),
      _$ = $(function () {
        var e = !!d,
          t = M(b, l, s, v, h, !l);
        return [t, X(t, e), W(t, e), e];
      }),
      _$2 = _slicedToArray(_$, 4),
      E = _$2[0],
      H = _$2[1],
      J = _$2[2],
      q = _$2[3];
    b !== E.C() && E.L(5, [b, c]), _ !== E.J() && E.L(6, _);
    var O = U(E),
      _E$m = E.m(),
      _E$m2 = _slicedToArray(_E$m, 2),
      P = _E$m2[0],
      Y = _E$m2[1],
      j = E.W(),
      F = E.q(),
      G = E.h(),
      K = [],
      N = function N(t) {
        var n = y(t);
        return e.jsx(D, {
          K: H.F,
          N: t,
          Z: E.T(t),
          ee: E.k(t),
          te: g,
          G: n,
          ne: q,
          re: z[B]
        }, L(n, t));
      };
    C(function () {
      z[B] = !1;
      var e = E.O(1, function (e) {
          e ? n.flushSync(O) : O();
        }),
        t = E.O(4, function () {
          k[B] && k[B](E.H());
        }),
        r = E.O(8, function () {
          R[B] && R[B]();
        }),
        o = function o(e) {
          H.V(e), J.X(e);
        };
      return m ? a(function () {
        return o(m[B]);
      }) : o(I[B].parentElement), function () {
        e(), t(), r(), H.A(), J.A();
      };
    }, []), C(function () {
      J.P();
    }, [F]), t.useImperativeHandle(x, function () {
      return {
        get cache() {
          return E.p();
        },
        get scrollOffset() {
          return E.H();
        },
        get scrollSize() {
          return T(E);
        },
        get viewportSize() {
          return E._();
        },
        findStartIndex: E.S,
        findEndIndex: E.I,
        getItemOffset: E.T,
        getItemSize: E.M,
        scrollToIndex: J.D,
        scrollTo: J.Y,
        scrollBy: J.j
      };
    }, []);
    for (var _e12 = P, _t7 = Y; _e12 <= _t7; _e12++) K.push(N(_e12));
    if (f) {
      var _e13 = [],
        _t8 = [];
      u(f).forEach(function (n) {
        n < P && _e13.push(N(n)), n > Y && _t8.push(N(n));
      }), K.unshift.apply(K, _e13), K.push.apply(K, _t8);
    }
    return e.jsx(p, {
      ref: I,
      style: {
        overflowAnchor: "none",
        flex: "none",
        position: "relative",
        visibility: "hidden",
        width: q ? G : "100%",
        height: q ? "100%" : G,
        pointerEvents: j ? "none" : void 0
      },
      children: K
    });
  }),
  G = t.forwardRef(function (_ref11, m) {
    var n = _ref11.children,
      o = _ref11.count,
      i = _ref11.overscan,
      s = _ref11.itemSize,
      l = _ref11.shift,
      c = _ref11.horizontal,
      d = _ref11.keepMounted,
      f = _ref11.reverse,
      u = _ref11.cache,
      a = _ref11.ssrCount,
      h = _ref11.item,
      _ = _ref11.onScroll,
      v = _ref11.onScrollEnd,
      p = _ref11.style,
      g = _objectWithoutProperties(_ref11, _excluded);
    var w = t.useRef(r),
      S = f && !c;
    var x = e.jsx(F, {
      ref: m,
      scrollRef: S ? w : void 0,
      count: o,
      overscan: i,
      itemSize: s,
      shift: l,
      horizontal: c,
      keepMounted: d,
      cache: u,
      ssrCount: a,
      item: h,
      onScroll: _,
      onScrollEnd: v,
      children: n
    });
    return S && (x = e.jsx("div", {
      style: {
        visibility: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        minHeight: "100%"
      },
      children: x
    })), e.jsx("div", _objectSpread(_objectSpread({
      ref: w
    }, g), {}, {
      style: _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        display: c ? "inline-block" : "block"
      }, c ? "overflowX" : "overflowY", "auto"), "contain", "strict"), "width", "100%"), "height", "100%"), p),
      children: x
    }));
  }),
  K = t.forwardRef(function (_ref12, p) {
    var o = _ref12.children,
      i = _ref12.count,
      s = _ref12.overscan,
      l = _ref12.itemSize,
      c = _ref12.shift,
      d = _ref12.horizontal,
      f = _ref12.cache,
      u = _ref12.ssrCount,
      _ref12$as = _ref12.as,
      a = _ref12$as === void 0 ? "div" : _ref12$as,
      _ref12$item = _ref12.item,
      h = _ref12$item === void 0 ? "div" : _ref12$item,
      _ = _ref12.onScroll,
      v = _ref12.onScrollEnd;
    var _V3 = V(o, i),
      _V4 = _slicedToArray(_V3, 2),
      g = _V4[0],
      m = _V4[1],
      w = t.useRef(r),
      S = A(_),
      x = A(v),
      y = t.useRef(!!u),
      _$3 = $(function () {
        var e = !!d,
          t = M(m, l, s, u, f, !l);
        return [t, Y(t, e), J(t, e), e];
      }),
      _$4 = _slicedToArray(_$3, 4),
      b = _$4[0],
      I = _$4[1],
      z = _$4[2],
      k = _$4[3];
    m !== b.C() && b.L(5, [m, c]);
    var R = U(b),
      _b$m = b.m(),
      _b$m2 = _slicedToArray(_b$m, 2),
      T = _b$m2[0],
      E = _b$m2[1],
      H = b.W(),
      W = b.q(),
      q = b.h(),
      O = [];
    C(function () {
      y[B] = !1;
      var e = b.O(1, function (e) {
          e ? n.flushSync(R) : R();
        }),
        t = b.O(4, function () {
          S[B] && S[B](b.H());
        }),
        r = b.O(8, function () {
          x[B] && x[B]();
        }),
        o = w[B];
      return I.V(o), z.X(o), function () {
        e(), t(), r(), I.A(), z.A();
      };
    }, []), C(function () {
      z.P();
    }, [W]), t.useImperativeHandle(p, function () {
      return {
        get cache() {
          return b.p();
        },
        findStartIndex: b.S,
        findEndIndex: b.I
      };
    }, []);
    for (var _t9 = T, _n6 = E; _t9 <= _n6; _t9++) {
      var _n7 = g(_t9);
      O.push(e.jsx(D, {
        K: I.F,
        N: _t9,
        Z: b.T(_t9),
        ee: b.k(_t9),
        te: h,
        G: _n7,
        ne: k,
        re: y[B]
      }, L(_n7, _t9)));
    }
    return e.jsx(a, {
      ref: w,
      style: {
        flex: "none",
        position: "relative",
        visibility: "hidden",
        width: k ? q : "100%",
        height: k ? "100%" : q,
        pointerEvents: H ? "none" : void 0
      },
      children: O
    });
  }),
  N = function N(e, t) {
    return "".concat(e, "-").concat(t);
  },
  Q = t.memo(function (_ref13) {
    var n = _ref13.G,
      o = _ref13.K,
      i = _ref13.oe,
      s = _ref13.ie,
      l = _ref13.se,
      c = _ref13.le,
      d = _ref13.ce,
      f = _ref13.de,
      u = _ref13.ee,
      a = _ref13.fe;
    var h = t.useRef(r);
    return C(function () {
      return o.F(h[B], i, s);
    }, [s, i]), e.jsx(a, {
      ref: h,
      style: t.useMemo(function () {
        return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
          display: "grid",
          position: "absolute",
          top: l
        }, z() ? "right" : "left", c), "visibility", u ? "hidden" : "visible"), "minHeight", d), "minWidth", f);
      }, [l, c, f, d, u]),
      children: n
    });
  }),
  Z = t.forwardRef(function (_ref15, v) {
    var o = _ref15.children,
      i = _ref15.row,
      s = _ref15.col,
      _ref15$cellHeight = _ref15.cellHeight,
      l = _ref15$cellHeight === void 0 ? 40 : _ref15$cellHeight,
      _ref15$cellWidth = _ref15.cellWidth,
      c = _ref15$cellWidth === void 0 ? 100 : _ref15$cellWidth,
      _ref15$overscan = _ref15.overscan,
      d = _ref15$overscan === void 0 ? 2 : _ref15$overscan,
      f = _ref15.initialRowCount,
      u = _ref15.initialColCount,
      _ref15$item = _ref15.item,
      a = _ref15$item === void 0 ? "div" : _ref15$item,
      h = _ref15.style,
      _ = _objectWithoutProperties(_ref15, _excluded2);
    var _$5 = $(function () {
        var e = M(i, l, d, f),
          t = M(s, c, d, u);
        return [e, t, j(e, t), q(e, t)];
      }),
      _$6 = _slicedToArray(_$5, 4),
      p = _$6[0],
      g = _$6[1],
      m = _$6[2],
      w = _$6[3];
    i !== p.C() && p.L(5, [i]), s !== g.C() && g.L(5, [s]);
    var S = U(p),
      x = U(g),
      _p$m = p.m(),
      _p$m2 = _slicedToArray(_p$m, 2),
      y = _p$m2[0],
      b = _p$m2[1],
      _g$m = g.m(),
      _g$m2 = _slicedToArray(_g$m, 2),
      I = _g$m2[0],
      z = _g$m2[1],
      k = p.W(),
      R = g.W(),
      E = p.q(),
      H = g.q(),
      W = T(p),
      J = T(g),
      O = t.useRef(r);
    C(function () {
      var e = O[B],
        t = p.O(1, function (e) {
          e ? n.flushSync(S) : S();
        }),
        r = g.O(1, function (e) {
          e ? n.flushSync(x) : x();
        });
      return m.V(e), w.X(e), function () {
        t(), r(), m.A(), w.A();
      };
    }, []), C(function () {
      w.P();
    }, [E, H]), t.useImperativeHandle(v, function () {
      return {
        get scrollTop() {
          return p.H();
        },
        get scrollLeft() {
          return g.H();
        },
        get scrollHeight() {
          return T(p);
        },
        get scrollWidth() {
          return T(g);
        },
        get viewportHeight() {
          return p._();
        },
        get viewportWidth() {
          return g._();
        },
        scrollToIndex: w.D,
        scrollTo: w.Y,
        scrollBy: w.j
      };
    }, []);
    var L = t.useMemo(function () {
        var e = new Map();
        return function (t, n) {
          var r = e.get(N(t, n));
          return r || e.set(N(t, n), r = o({
            rowIndex: t,
            colIndex: n
          })), r;
        };
      }, [o]),
      A = [];
    for (var _t10 = y; _t10 <= b; _t10++) for (var _n8 = I; _n8 <= z; _n8++) A.push(e.jsx(Q, {
      K: m,
      oe: _t10,
      ie: _n8,
      se: p.T(_t10),
      le: g.T(_n8),
      ce: p.M(_t10),
      de: g.M(_n8),
      ee: p.k(_t10) || g.k(_n8),
      fe: a,
      G: L(_t10, _n8)
    }, N(_t10, _n8)));
    return e.jsx("div", _objectSpread(_objectSpread({
      ref: O
    }, _), {}, {
      style: _objectSpread({
        overflow: "auto",
        contain: "strict",
        width: "100%",
        height: "100%"
      }, h),
      children: e.jsx("div", {
        style: {
          overflowAnchor: "none",
          flex: "none",
          position: "relative",
          visibility: "hidden",
          width: J,
          height: W,
          pointerEvents: k || R ? "none" : void 0
        },
        children: A
      })
    }));
  });
exports.VList = G, exports.Virtualizer = F, exports.WindowVirtualizer = K, exports.experimental_VGrid = Z;